import { jsx } from 'react/jsx-runtime';
import { classNames } from '../../utils/functions/classNames/classNames.js';

const Modal = ({ children, className, }) => jsx("div", Object.assign({ className: classNames('modal', className) }, { children: children }));

export { Modal };
